import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { map, tap } from 'rxjs/operators';
import { WaterTransferDocumentServiceStore } from '@app/services/water-transfer-document/store/water-transfer-document-service.store';
import { WaterTransferDocumentServiceService } from '@app/services/water-transfer-document/services/water-transfer-document-service.service';

export const waterTransferDocumentGuard: CanActivateFn = (route, state) => {
    const waterTransferDocumentServiceStore = inject(WaterTransferDocumentServiceStore);
    const waterTransferDocumentServiceService = inject(WaterTransferDocumentServiceService);
    const moveSandbox = inject(MoveSandbox);
    const router = inject(Router);

    const waterTransferDocumentService = waterTransferDocumentServiceStore.waterTransferDocumentService();
    if (waterTransferDocumentService) {
        if (!waterTransferDocumentService.active) {
            void router.navigate(['/']);
            return false;
        }
        return true;
    }
    const transactionId = moveSandbox.transactionId();
    return waterTransferDocumentServiceService.getWaterService(transactionId).pipe(
        map((data) => data.active),
        tap((active) => {
            if (!active) {
                void router.navigate(['/']);
            }
        }),
    );
};
